import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from "../../../Helpers/Navigation";
import { isLogin } from "../../../../lib/constant";
import PopupModal from "../../../../containers/PopupModal";
import { toast } from "react-toastify";
import "./index.css";

const MainHeader = ({ drawerAction, searchAction }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const logOutClicked = async (e) => {
    e.preventDefault();
    localStorage.removeItem("is_authenticated");
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    isLogin();
    navigate("/");
    setModalIsOpen(false);
    toast("Logout Successfully", { type: "success" });
  };

  return (
    <>
      <header className={`dp-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="dp-header-inner">
          {/* Logo */}
          <Link to="/" className="dp-header-logo">
            <img
              src={require(`../../../../assets/images/dream-prize.jpeg`).default}
              alt="DreamPrize"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="dp-header-nav">
            <Navigation />
          </nav>

          {/* Header Actions */}
          <div className="dp-header-actions">
            {/* Cart Icon */}
            {isLogin() && (
              <Link to="/cart" className="dp-header-icon-btn" title="Cart">
                <i className="far fa-shopping-cart"></i>
              </Link>
            )}

            {/* User Dropdown */}
            <div className="dp-user-dropdown">
              <button className="dp-user-btn">
                <i className="far fa-user"></i>
                <i className="fa fa-angle-down"></i>
              </button>

              <div className="dp-dropdown-menu">
                {isLogin() ? (
                  <>
                    <Link to="/wallet" className="dp-dropdown-item">
                      <i className="far fa-wallet"></i>
                      <span>Wallet</span>
                    </Link>
                    <Link to="/account-detail" className="dp-dropdown-item">
                      <i className="far fa-user-circle"></i>
                      <span>My Account</span>
                    </Link>
                    <div className="dp-dropdown-divider"></div>
                    <div
                      className="dp-dropdown-item logout"
                      onClick={() => setModalIsOpen(true)}
                    >
                      <i className="far fa-sign-out"></i>
                      <span>Log Out</span>
                    </div>
                  </>
                ) : (
                  <>
                    <Link to="/login" className="dp-dropdown-item">
                      <i className="far fa-sign-in"></i>
                      <span>Login</span>
                    </Link>
                    <Link to="/register" className="dp-dropdown-item">
                      <i className="far fa-user-plus"></i>
                      <span>Register</span>
                    </Link>
                  </>
                )}
              </div>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={drawerAction}
              className="dp-mobile-menu-btn"
              aria-label="Open menu"
            >
              <i className="fal fa-bars"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Logout Confirmation Modal */}
      <PopupModal
        title="Are you sure you want to Logout?"
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        yesClicked={logOutClicked}
      />
    </>
  );
};

export default MainHeader;
